import React, {Component} from 'react';

const GoogleAnalyticsHOC = (WrappedComponent) => {
  return class WithGoogleAnalytics extends Component{

      componentDidMount() {
          this.setDataLayer();
      }

      componentDidUpdate(prevProps, prevState, snapshot) {
          if(this.props.location.pathname !== prevProps.location.pathname){
              this.setDataLayer();
          }
      }

      setDataLayer = () => {
           const dataLayer = {
               'event' : 'VirtualPageview',
               'language': 'en',
               'status' : this.props.isAuth?'signed in':'signed out',
               'virtualPageURL': this.props.location.pathname
           };

           if(window.dataLayer){
               window.dataLayer.push(dataLayer)

           } else {
               window.dataLayer = [dataLayer];

               (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                       new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                   j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                   'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
               })(window,document,'script','dataLayer','GTM-T2P4T2N');
           }


      };

      render(){
          return <WrappedComponent {...this.props}/>
      }
  }
};

export default GoogleAnalyticsHOC;